<lvr-heading [showEditButton]="false">
	{{ 'assignment.details.end_report' | transloco }}
	<div ngProjectAs="button-content">
		@if (report()?.isFinal) {
			<lvr-button
				variant="primary"
				[label]="'base.button.export' | transloco"
				[loadingLabel]="'base.button.generating_pdf' | transloco"
				[ariaLabel]="'base.button.export_pdf' | transloco"
				[loading]="isExporting()"
				[type]="'button'"
				(clicked)="export('abschlussbericht.pdf')"
				icon="ios_share"
			></lvr-button>
		}
	</div>
</lvr-heading>
<lvr-section>
	<form class="preview-grid" [formGroup]="form">
		<div>
			@if (!report()?.isFinal) {
				@if (availableImpediments() && availableImpediments()!.length > 0) {
					<p style="margin: 0 0 16px 0">{{ 'assignment.details.impediments_end_report' | transloco }}</p>

					@let impedimentCtrl = form.controls.impediments;
					<lvr-impediment-list
						formControlName="impediments"
						[groups]="availableImpediments() ?? []"
						[required]="true"
						[hasError]="(impedimentCtrl?.invalid ?? false) && (impedimentCtrl?.touched ?? false)"
					></lvr-impediment-list>
				} @else if (!assignment()?.isAdditionalAssignment) {
					<p>{{ 'assignment.details.no_impediments' | transloco }}</p>
				}
			}
		</div>
		@if (renderContent()) {
			<lvr-html-editor
				(docChange)="docUpdated($event)"
				[html]="renderContent()"
				[readOnly]="(report()?.isFinal ?? false) || !canEditReport()"
			></lvr-html-editor>
		}
	</form>
</lvr-section>

<lvr-section>
	@if (!report()?.isFinal) {
		<div
			[matTooltip]="!canEditReport() ? ('base.button.edit_disabled' | transloco) : ''"
			[matTooltipDisabled]="canEditReport()"
		>
			<lvr-default-actions
				[disableSave]="!updateHtmlContent() || !canEditReport()"
				(save)="save()"
				(cancelSave)="cancel()"
				[showLoading]="isLoadingForSaveEndReport()"
			></lvr-default-actions>
		</div>
	}
</lvr-section>
